export default "__VITE_ASSET__D$i$QPt___"